import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { AboutComponent } from './components/pages/about/about.component';
import { CaseStudiesComponent } from './components/pages/placements/case-studies.component';
import { BlogComponent } from './components/pages/courses/blog.component';
import { BlogDetailsComponent } from './components/pages/admissions/blog-details.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { ContactComponent } from './components/pages/contact/contact.component';

const routes: Routes = [
    {path: '', component: HomeOneComponent},
    {path: 'about', component: AboutComponent},
    {path: 'courses', component: BlogComponent},
    {path: 'admissions', component: BlogDetailsComponent},
    {path: 'placements', component: CaseStudiesComponent},
    {path: 'error', component: ErrorComponent},
    {path: 'contact', component: ContactComponent},
    // Here add new pages component

    {path: '**', component: ErrorComponent} // This line will remain down from the whole pages component list

];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }